import { Component } from "react";
import './ReviewPaymentForms.css';
import { TableColumn } from "react-data-table-component";
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import FormServices from "../../Services/FormServices";
import DataGrid from "../../Components/DataGrid/DataGrid";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CustomMaterialMenu from "../../Components/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu";
import { ShowAlert } from "../../Components/ShowAlert";
const MySwal = withReactContent(Swal);

export interface IfileType {
    envelopeId: string,
    formType: string
}

export interface IFaxLetterType {
    userInstallmentId: string,
    letterType: string
}

export interface IReviewPaymentFormsList {
    userId: string,
    userName: string,
    email: string,
    planName: string,
    reviewStatus: string,
    transmitToIRSStatus: string,
    form433A: IfileType,
    form433D: IfileType,
    form433AOIC: IfileType,
    faxLetter: IFaxLetterType
}

export interface IReviewPaymentFormState {
    userlist: IReviewPaymentFormsList[],
    accessToken: string;
    currentPage: number,
    currentRowsPerPage: number,
    searchText: string,
    totalRows: number,
    currentSortColumn: string,
    sortingDirection: string,
    files: IfileType[]
}

interface IReviewPaymentFormsProps {

    onPopupClose?: () => void
}

class ReviewPaymentForms extends Component<IReviewPaymentFormsProps, IReviewPaymentFormState> {
    constructor(_props: any) {
        super(_props);
        this.state = {
            userlist: [],
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            currentSortColumn: '',
            sortingDirection: '',
            files: []
        }

    }

    private formColumns: TableColumn<IReviewPaymentFormsList>[] = [
        {
            name: 'Taxpayer Name',
            selector: (row: IReviewPaymentFormsList) => row.userName,
            minWidth: '175px',
            maxWidth: '325px'
        },
        {
            name: 'Email',
            selector: (row: IReviewPaymentFormsList) => row.email,
            sortable: true,
            maxWidth: '175px'
        },
        {
            name: 'Payment Plan',
            selector: (row: IReviewPaymentFormsList) => row.planName,
            sortable: true,
            maxWidth: '200px'
        },
        {
            name: 'Review Status',
            selector: (row: IReviewPaymentFormsList) => row.reviewStatus,
            maxWidth: '120px'
        },
        {
            name: 'Transmit to IRS',
            selector: (row: IReviewPaymentFormsList) => row.transmitToIRSStatus,
            maxWidth: '150px'
        },
        {
            name: 'Documents',
            cell: (row: IReviewPaymentFormsList) => (
                <button
                    className='view-documents-btn'
                    onClick={(event) => {
                        this.viewDocuments(row);
                    }}>
                    View Documents
                </button>
            ),
            width: '200px'
        },
        {
            cell: row => <CustomMaterialMenu
                fontSize="small"
                multiPopoverItems={[
                    {
                        key: "formReview",
                        label: "Approve",
                        disabled: (row.reviewStatus == 'Approved'),
                        textStyle: (row.reviewStatus == 'Approved') ? 'cv-disabled' : ''
                    },
                    {
                        key: "formApprove",
                        label: "Transmit to IRS",
                        disabled: (row.transmitToIRSStatus == 'Approved' || row.reviewStatus != 'Approved'),
                        textStyle: (row.transmitToIRSStatus == 'Approved' || row.reviewStatus != 'Approved') ? 'cv-disabled' : ''
                    },
                ]}
                onPopoverClick={(key_: string, label_: string) => {
                    if (key_ === 'formReview') {
                        this.confirmReview(row);
                    }
                    if (key_ === 'formApprove') {
                        this.confirmTransmitToIRS(row);
                    }
                }}
            />,
            allowOverflow: true,
            button: true,
            width: '56px'
        }
    ];

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getReviewList();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    getReviewList() {
        let postData = {
            sort: {
                column: this.state.currentSortColumn,
                direction: this.state.sortingDirection
            },
            limit: this.state.currentRowsPerPage,
            offset: (this.state.currentPage - 1) * this.state.currentRowsPerPage,
            searchFilter: this.state.searchText
        };
        FormServices.getPaymentReviewPendingUsers(postData, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then(response => {
                    this.setState({ userlist: response.data, totalRows: response.totalCount });
                })
            }
        });
    }

    identifySortingMapColumn(columnName: string) {
        let actualColName = '';
        switch (columnName) {
            case "Taxpayer Name":
                actualColName = 'userName';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Payment Plan":
                actualColName = 'planName';
                break;

        }
        return actualColName;
    }

    viewDocuments(row: IReviewPaymentFormsList) {

        MySwal.fire({
            title: `Documents for ${row.userName}`,
            html: this.renderDocumentTableWithActions(row),
            showCloseButton: true,
            showConfirmButton: false,
            width: '900px',
            customClass: {
                popup: 'document-popup'
            },
            didClose: () => {

                this.getReviewList();
            }
        });
    }

    renderDocumentTableWithActions(row: IReviewPaymentFormsList) {
        console.log(row)
        let files = [];
        if (row.form433A.envelopeId) {
            files.push({ envelopeId: row.form433A.envelopeId, formType: 'Form 433-A' });
        }
        if (row.form433D.envelopeId) {
            console.log('form 433D')
            files.push({ envelopeId: row.form433D.envelopeId, formType: 'Form 433-D' });
        }
        if (row.form433AOIC.envelopeId) {
            files.push({ envelopeId: row.form433AOIC.envelopeId, formType: 'Form 433-A-OIC' });
        }
        if (row.faxLetter.userInstallmentId) {
            files.push({ envelopeId: row.faxLetter.userInstallmentId, formType: 'Letter', letterType: row.faxLetter.letterType });
        }
        this.setState({ files: [...files] });
        console.log(this.state.files, files, 'files')
        if (!files || files.length === 0) {
            return (
                <div style={{ textAlign: 'center' }}>
                    <p>No documents available for this user.</p>
                </div>
            );
        }

        return (
            <div className="table-container">


                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                            <th className="expense-val-table-cell expense-val-table-header">Serial No</th>
                            <th className="expense-val-table-cell expense-val-table-header">Forms / Letter Documents</th>

                        </tr>
                    </thead>
                    <tbody>
                        {files.map((doc, index) => (
                            <tr key={index}>
                                <td className="expense-val-table-cell">{index + 1}</td>
                                <td className="expense-val-table-cell">
                                    {doc ? (
                                        <p
                                            className="expense-proof-file"
                                            onClick={(event) => {
                                                event.preventDefault();
                                                this.downloadFile(doc.envelopeId, doc.formType, doc.letterType);
                                            }}
                                        >
                                            {doc.formType}
                                        </p>
                                    ) : (
                                        '-'
                                    )}
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );

    }

    async confirmReview(row: IReviewPaymentFormsList) {
        Swal.fire({
            title: `Approve Payment Plan?`,
            html: `
                      <div style="text-align: left;">
                          <p>Are you sure you want to approve the payment plan document for <b>${row.userName}</b>?</p>
                      </div>
                  `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                this.reviewDocument(row);
            }
        });
    }

    async confirmTransmitToIRS(row: IReviewPaymentFormsList) {
        Swal.fire({
            title: `Transmit to IRS`,
            html: `
                        <div style="text-align: left;">
                            <p>Are you sure you want to transmit the payment plan document for <b>${row.userName}</b> to the IRS?</p>
                        </div>
                    `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                this.approveDocument(row);
            }
        });
    }

    approveDocument(row: IReviewPaymentFormsList) {
        let body = {
            userId: row.userId,
            isApproved: true
        };
        FormServices.approvePaymentDoc(body, this.state.accessToken, true).then(response => {
            ShowAlert("EasyAly Tax Resolution", `The payment plan document for ${row.userName} has been successfully transmitted to the IRS.`, 'success');
            this.getReviewList();
        }).catch(err => {
            ShowAlert("EasyAly Tax Resolution", "Failed to approve the plan", 'error')

        })
    }

    reviewDocument(row: IReviewPaymentFormsList) {
        let body = {
            userId: row.userId,
            isApproved: true
        };
        FormServices.approvePaymentDoc(body, this.state.accessToken, false).then(response => {
            ShowAlert("EasyAly Tax Resolution", `The payment plan document for ${row.userName} has been successfully approved.`, 'success');
            this.getReviewList();
        }).catch(err => {
            ShowAlert("EasyAly Tax Resolution", "Failed to review the plan", 'error')

        })
    }

    downloadLetter(fileId: string, fileName: string, letterType: string | undefined) {
        let body = {
            userInstallmentId: fileId,
            letterType: letterType
        };
        FormServices.downloadPaymentLetter(body, this.state.accessToken).then((response) => {
            if (response.ok) {
                response.json().then(data => {

                    // Handle different response formats
                    let base64Data = data.body;

                    if (base64Data && typeof base64Data === 'string') {
                        try {
                            ///... Clean the base64 string - remove any whitespace and ensure it's properly formatted
                            base64Data = base64Data.replace(/\s/g, '');

                            ///... Convert base64 to blob
                            const byteCharacters = atob(base64Data);
                            const byteNumbers = new Array(byteCharacters.length);
                            for (let i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            const byteArray = new Uint8Array(byteNumbers);
                            const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });


                            // Create blob link to download
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = fileName + '.docx';

                            // Append to html link element page
                            document.body.appendChild(link);

                            // Start download
                            link.click();

                            // Clean up and remove the link
                            link.parentNode?.removeChild(link);
                            window.URL.revokeObjectURL(url);

                        } catch (error) {

                        }
                    } else {

                    }
                });
            } else {

            }
        }).catch((err: any) => {

        });
    }

    downloadFile(fileId: string, fileName: string, letterType: string | undefined) {
        let body = {
            envelopeId: fileId,
            isSubmittedtoIRS: 0,
            formType: fileName == 'Form 433-A' ? 'form-433A' : 'form-433D'
        };

        if (fileName == 'Letter') {
            this.downloadLetter(fileId, fileName, letterType);
            return;
        }

        FormServices.downloadDocusignedPDF(body, this.state.accessToken).then((response) => {
            if (response.ok) {
                response.json().then(data => {

                    // Handle different response formats
                    let base64Data = data.body;

                    if (base64Data && typeof base64Data === 'string') {
                        try {
                            ///... Clean the base64 string - remove any whitespace and ensure it's properly formatted
                            base64Data = base64Data.replace(/\s/g, '');

                            ///... Convert base64 to blob
                            const byteCharacters = atob(base64Data);
                            const byteNumbers = new Array(byteCharacters.length);
                            for (let i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            const byteArray = new Uint8Array(byteNumbers);
                            const blob = new Blob([byteArray], { type: 'application/pdf' });


                            // Create blob link to download
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = fileName;

                            // Append to html link element page
                            document.body.appendChild(link);

                            // Start download
                            link.click();

                            // Clean up and remove the link
                            link.parentNode?.removeChild(link);
                            window.URL.revokeObjectURL(url);

                        } catch (error) {

                        }
                    } else {

                    }
                });
            } else {

            }
        }).catch((err: any) => {

        });
    }

    public render() {


        return (
            <div className='body-sub-contianer table-container'>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    title='Review Payment Form'
                    search='Payment Form Details'
                    columns={this.formColumns}
                    data={this.state.userlist}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getReviewList();
                        })
                    }}

                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                        this.setState({
                            currentPage: currentPage,
                            currentRowsPerPage: currentRowsPerPage
                        }, () => {
                            this.getReviewList();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        console.log(page, totalRows);
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getReviewList();
                        })
                    }}
                    onSort={(column: any, direction) => {

                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1
                        }, () => {
                            this.getReviewList();
                        })
                    }}
                    pagination
                    paginationTotalRows={this.state.totalRows}
                />
            </div>
        )
    }
}

export default ReviewPaymentForms;
